import React, { useEffect } from 'react'
import { Grid, Container, makeStyles } from '@material-ui/core'
import { useSearchParam } from '../../../../../hooks/useSearchParam'
import { useSchwabExchange } from './hooks'

const useStyles = makeStyles({
  formContainer: {
    display: 'flex',
    border: 'var(--border-neutral-thin)',
    borderRadius: 'var(--border-radius-sm)',
    padding: '2rem',
    justifyContent: 'center',
    alignContent: 'center'
  },
  headerText: {
    fontSize: '2rem',
    textAlign: 'center'
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    '& .__button': {
      borderRadius: 'var(--border-radius-round)',
      border: 'var(--border-neutral-normal)',
      backgroundColor: '#FFF',
      textTransform: 'none',
      padding: '0.5rem 1rem',
      maxHeight: '2.5rem'
    }
  }
})

const Callback = (props) => {
  const code = useSearchParam('code')
  const state = useSearchParam('state')

  const classes = useStyles()
  const { handleExchange } = useSchwabExchange(code, state)

  useEffect(() => {
    handleExchange()
  }, [handleExchange])
  return (
    <Container maxWidth='md' style={{ paddingTop: '1rem' }}>
      <div className={classes.formContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <h3 className={classes.headerText}>Successfully Authenticated!</h3>
          </Grid>
        </Grid>
      </div>
    </Container>
  )
}

export default Callback
